export default __webpack_public_path__ + "static/media/tramy_news_3.29935946.svg";